export default "__VITE_ASSET__80f3f3d2__"